import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "truncate" })
export class TruncatePipe implements PipeTransform {

    constructor() {

    }

    transform(value: string, positionTruncateChar: number): string {

        let tempPosition = positionTruncateChar;
        if(value){
            if (positionTruncateChar < 0) {
                return value;
            }
            else {

                if (value.length < positionTruncateChar) {
                    return value;
                }
                else {
                    while (value.charAt(positionTruncateChar) != ' ' && positionTruncateChar > 0) {
                        positionTruncateChar--;
                    }
                    if (positionTruncateChar == 0) {
                        return value.substring(0,tempPosition) + "....";
                    }
                    else {
                        return value.substring(0, positionTruncateChar) + "...";
                    }
                }
            }
        }
        else
        {
            return value;
        }
    }
}